// @flow
/** @jsx jsx */

import * as React from 'react';

import { Border, Colors } from '@zapier/theme';
import {
  PropsQueriesType,
  PropsQuery,
} from '@zapier/common-components/src/components/PropsQuery';
import { css, jsx } from '@emotion/core';

type DirectionType = 'horizontal' | 'vertical';

type Props = {
  children: React.Node | Array<React.Node>,
  /** List flow direction */
  direction?: DirectionType,
  /** Props Queries */
  propsQueries?: PropsQueriesType,
};

const spacing = 13;

const cellCss = {
  alignItems: 'center',
  display: 'flex',

  '&:not(:last-of-type)': {
    marginRight: 2 * spacing,
  },
};

const listCss = {
  color: Colors.batmobile,
  listStyleType: 'none',
  margin: 0,
  marginBlockEnd: 0,
  marginBlockStart: 0,
  paddingBottom: spacing,
  paddingInlineStart: 0,
  position: 'relative',
  WebkitMarginAfter: 0,
  WebkitMarginBefore: 0,
  WebkitPaddingStart: 0,
  width: '100%',
};

const rowCss = (direction: DirectionType) =>
  css(
    {
      alignItems: 'center',
      border: '1px solid transparent',
      borderRadius: 0,
      display: 'flex',
      justifyContent: 'space-between',
      listStyle: 'none',
      padding: spacing,

      '&:not(:last-of-type)': {
        borderBottom: `${Border.size.default} solid ${Border.color.default}`,
      },
    },
    direction === 'vertical' && {
      border: `${Border.size.default} solid ${Border.color.default}`,
      borderRadius: 4,
      display: 'block',
      padding: 0,

      ':not(:last-of-type)': {
        marginBottom: spacing,
      },
    }
  );

const Item = ({ children, direction = 'horizontal' }: Props) => (
  <li css={rowCss(direction)}>{children}</li>
);

const Cell = ({ children }) => <div css={cellCss}>{children}</div>;

const CollapsibleList = ({ children, direction, propsQueries }: Props) => {
  return (
    <PropsQuery queries={propsQueries}>
      {overrides => {
        const childrenWithDirection = React.Children.map(children, child =>
          React.cloneElement(child, { direction, ...overrides })
        );
        return <ul css={listCss}>{childrenWithDirection}</ul>;
      }}
    </PropsQuery>
  );
};

CollapsibleList.Item = Item;
CollapsibleList.Cell = Cell;

CollapsibleList.defaultProps = {
  direction: 'horizontal',
};

export default CollapsibleList;
